// RevisionNotesDialog.tsx — Add / edit revision notes for the active panel

import { useState } from 'react';
import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';
import type { MpVar } from '../types/panelvar';

export default function RevisionNotesDialog() {
  const { ui, project, updateMpVar } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updateMpVar: s.updateMpVar,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [revision, setRevision] = useState(panel?.mpvar.revision ?? '');
  const [date,     setDate]     = useState(panel?.mpvar.date ?? '');
  const [notes,    setNotes]    = useState(panel?.mpvar.notes ?? '');
  if (!panel) return null;

  return (
    <DialogBase
      title="Revision Notes"
      onOk={() => updateMpVar(panel.id, { revision, date, notes } as Partial<MpVar>)}
    >
      <div className="dialog-row">
        <label className="dialog-label">Revision</label>
        <input className="dialog-input" type="text" value={revision}
          onChange={e => setRevision(e.target.value)} />
      </div>
      <div className="dialog-row">
        <label className="dialog-label">Revision Date</label>
        <input className="dialog-input" type="text" value={date}
          onChange={e => setDate(e.target.value)} />
      </div>
      <div className="dialog-row">
        <label className="dialog-label">Notes</label>
        <textarea
          className="dialog-textarea"
          value={notes}
          rows={4}
          onChange={e => setNotes(e.target.value)}
        />
      </div>
    </DialogBase>
  );
}
